import React, { FC } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { MotionConfig } from 'framer-motion';
import { ThemeProvider } from './theme';
import { store } from './redux';
import { PMQueryProvider } from './api';
import { GameRoutes } from './router';

import { AlertProvider, PopUpBoxProvider } from './shared/components';

export const App: FC = () => {
  return (
    <ReduxProvider store={store}>
      <PMQueryProvider>
        <ThemeProvider>
          <AlertProvider />
          <PopUpBoxProvider>
            {/* honour the OS "reduce motion" setting for every card animation */}
            <MotionConfig reducedMotion="user">
              <GameRoutes />
            </MotionConfig>
          </PopUpBoxProvider>
        </ThemeProvider>
      </PMQueryProvider>
    </ReduxProvider>
  );
};
